class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    // Keep header cart icon as a normal link to the cart page; do not hijack click to open drawer
    return;
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Code Commented - Special Product related code
document.addEventListener("DOMContentLoaded", async function () {
    const customerId = document.getElementById('customer_id')?.value || null;
    const company_id = document.getElementById('company_id')?.value || null;
    const current_currency = document.getElementById('current_currency')?.value || 'USD';
    const location_id = document.getElementById('current_location')?.value || null;
    const app_url = document.getElementById('app_url')?.value || null;
    const email = document.getElementById('customer_email')?.value || null;
    //const customerId = '7979241635885';
    
    async function updateCartTotalFromCustomPrices() {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        let customTotal = 0;
        cart.items.forEach((item, index) => {
            const customPrice = item.properties?.custom_price;
            const qty = item.quantity;
            const price = (customPrice && !isNaN(parseFloat(customPrice)))
                ? parseFloat(customPrice)
                : item.price / 100;
            customTotal += price * qty;
            
            // Use the cart drawer item ID format
            const itemId = `CartDrawer-Item-${index + 1}`;
            const itemElement = document.getElementById(itemId);
            
            if (itemElement) {
                // Update product price in details section - only update the specific price element
                const productPriceEl = itemElement.querySelector(".cart-item__details .item-og-price");
                if (productPriceEl) {
                    productPriceEl.textContent = `$${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                    productPriceEl.style.display = 'block';
                }
                
                // Update line total price
                const priceEls = itemElement.querySelectorAll(".cart-item__totals .cart-item__price-wrapper .price");
                priceEls.forEach(pEl => {
                    let total_price = price * qty;
                    pEl.textContent = `$${total_price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                    pEl.style.display="block";
                });
            }
        });
        const formattedTotal = `$${customTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        const totalEl = document.querySelector('.totals__total-value');
        const HeadertotalEl = document.querySelector('#MiniCartSubtotal');
        if (totalEl) {
            totalEl.textContent = formattedTotal;
        }
        if (HeadertotalEl) {
            HeadertotalEl.textContent = formattedTotal;
        }
    }

    // Initial price update
    updateCartTotalFromCustomPrices();

    // If no customer, skip ERP pricing
    if (!customerId) return;
    if (!app_url) return;
    
    // Subscribe to cart updates to re-run price updates when cart changes
    const cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        // Add a small delay to ensure DOM is updated
        const priceEls = document.querySelectorAll(".cart-item__totals .cart-item__price-wrapper .price");
        priceEls.forEach(pEl => {
            pEl.style.display="none";
        });
        setTimeout(() => {
            updateCartTotalFromCustomPrices();
        }, 100);
    });

    // Clean up subscription when page unloads
    window.addEventListener('beforeunload', () => {
        if (cartUpdateUnsubscriber) {
            cartUpdateUnsubscriber();
        }
    });

    document.addEventListener("click", async (event) => {
        const target = event.target;

        if (target && target.id === "CartDrawer-Checkout") {
            event.preventDefault();
            event.stopImmediatePropagation();
            try {
                const cartResponse = await fetch("/cart.js");
                const cart = await cartResponse.json();

                const hasSpecialItem = cart.items.some(item => item.properties?.custom_product === "true");

                if (!hasSpecialItem) {
                    // allow normal checkout
                    window.location.href = "/checkout";
                    return;
                }

                // Create loader overlay if not already present
                let loader = document.getElementById("checkout-loader");
                if (!loader) {
                    loader = document.createElement("div");
                    loader.id = "checkout-loader";
                    loader.innerHTML = `
                    <div style="
                        position: fixed;
                        top:0; left:0; right:0; bottom:0;
                        background: rgba(255,255,255,0.8);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 9999;
                    ">
                        <div style="padding:20px; background:#fff; border-radius:8px; box-shadow:0 0 10px rgba(0,0,0,0.2); font-size:16px; font-weight:bold;">
                            Processing your order...
                        </div>
                    </div>
                `;
                    document.body.appendChild(loader);
                }
                loader.style.display = "flex";

                const items = cart.items.map(item => {
                    const customPrice = item.properties?.custom_price;
                    const defaultPrice = (item.price / 100).toFixed(2);
                    const finalPrice = (customPrice && !isNaN(parseFloat(customPrice)))
                        ? parseFloat(customPrice).toFixed(2)
                        : defaultPrice;

                    const item_properties = item.properties
                        ? Object.entries(item.properties)
                            .filter(([key, value]) => value !== null && value !== '')
                            .map(([key, value]) => ({ key, value }))
                        : [];

                    return {
                        variantId: item.variant_id,
                        quantity: item.quantity,
                        price: finalPrice,
                        title: item.product_title,
                        properties: item_properties
                    };
                });

                if (!customerId) {
                    console.log("Please log in to checkout with ERP pricing.");
                    loader.style.display = "none";
                    return;
                }

                const response = await fetch(app_url + "/api/create-draft-order", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        customerId,
                        email,
                        items,
                        company_id,
                        location_id,
                        currency: current_currency
                    })
                });

                const result = await response.json();

                if (result.success) {
                    window.location.href = result.invoice_url;
                } else {
                    showErrorPopup("We were unable to process your order. Please contact our support team for assistance.");
                }
            } catch (err) {
                console.error("Checkout error:", err);
                showErrorPopup("We were unable to process your order. Please contact our support team for assistance.");
            } finally {
                const loader = document.getElementById("checkout-loader");
                if (loader) loader.style.display = "none";
            }
        }
    });

// Reusable popup function
    function showErrorPopup(message) {
        let popup = document.getElementById("error-popup");
        if (!popup) {
            popup = document.createElement("div");
            popup.id = "error-popup";
            popup.innerHTML = `
            <div style="
                position: fixed;
                top:0; left:0; right:0; bottom:0;
                background: rgba(0,0,0,0.5);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 10000;
            ">
                <div style="background:#fff; padding:20px; border-radius:8px; text-align:center; max-width:300px;">
                    <p id="error-message" style="margin-bottom:15px; font-size:16px; font-weight:bold; color:#d00;"></p>
                    <button id="error-ok-btn" style="padding:8px 16px; background:#d00; color:#fff; border:none; border-radius:4px; cursor:pointer;">OK</button>
                </div>
            </div>
        `;
            document.body.appendChild(popup);
        }
        popup.querySelector("#error-message").innerText = message;
        popup.style.display = "flex";

        popup.querySelector("#error-ok-btn").onclick = () => {
            popup.style.display = "none";
        };
    }
});
*/